import {toast} from "react-semantic-toasts";
import i18n from "i18next";
export const showToast = (type: any, icon: any, title: string, description: string) => {
  setTimeout(() => {
    toast({
      type: type,
      icon: icon,
      title: title,
      description: description,
      time: 5000,
      size: "small",
    });
  }, 100);
};

export const showErrorToast = (header: string = "", error: string = "" ) => {
  setTimeout(() => {
    toast({
      type: "error",
      icon: "times circle outline",
      title: header === "" ? i18n.t("error") : header,
      description: error === "" ? i18n.t("not_found_error") : error,
      time: 5000,
      size: "small",
    });
  }, 100);
}